<app-dialog class="release-note-dialog">
  <ng-container dialog-title>
    <p class="title" *ngIf="data?.title === null || data?.title === ''">
      {{ 'module.shared.userProfileMenu.releaseNoteTitleText' | translate }}
    </p>
    <p class="title" *ngIf="data?.title !== ''">
      {{ data?.title }}
    </p>
  </ng-container>
  <ng-container dialog-content>
    <div class="content">
      <div *ngFor="let item of data?.releaseItems">
        <p class="release-date">{{ item?.releaseDate | localDate: 'yMMMdd' }}</p>

        <div class="release-description">
          <ul class="notes-list">
            <li *ngFor="let note of item?.notesList">
              {{ note }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </ng-container>
</app-dialog>
